import { JRCLoader } from 'components/JRCLoader/JRCLoader';
import { JRCTypography } from 'components/JRCTypography/JRCTypography';
import * as React from 'react';
import styled from 'styled-components';
import { JRCContainer } from './JRCContainer';
import { LayoutMode } from './template.type';

export type JRCTemplateBaseProps = {
    children: React.ReactNode;
    isLoading: boolean;
    loader?: React.ReactNode;
    title?: React.ReactNode;
    mode?: LayoutMode;
    maxWidth?: string;
};

export const ChildrenContainerStyle = styled.div`
    background-color: #ffffff;
    border: solid ${(props) => props.theme.color.grey2};
    border-width: var(--template-border-width);
    border-radius: var(--template-border-radius);
    display: block;
    width: 100%;
`;

export const Title = styled.div`
    padding: 24px 24px 0 24px;
`;
export const Main = styled.div`
    padding: 24px;
`;

export const ChildrenContainer = ({ title, isLoading, loader, children }: Omit<JRCTemplateBaseProps, 'maxWidth'>) => {
    return (
        <ChildrenContainerStyle>
            {title && (
                <Title>
                    <JRCTypography variant="h1" size="xl" weight="medium">
                        {title}
                    </JRCTypography>
                </Title>
            )}
            <Main>{isLoading ? loader ?? <JRCLoader size="l" /> : <>{children}</>}</Main>
        </ChildrenContainerStyle>
    );
};

export const JRCTemplateBase: React.FC<any> = ({
    title,
    isLoading,
    loader,
    children,
    mode = 'centerTop',
    maxWidth = '1280px',
}: JRCTemplateBaseProps) => {
    return (
        <JRCContainer mode={mode} maxWidth={maxWidth} flexDirection="column">
            <ChildrenContainer title={title} isLoading={isLoading} loader={loader}>
                {children}
            </ChildrenContainer>
        </JRCContainer>
    );
};
